import * as tags from '@wix/auto_sdk_tags_tags';

export { tags };
